import React from 'react';
import Pictogram from '../pictogram';
import TranslatedCopy from '../../../intl/translated-copy';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { HomeE4 } from '../../../../routing/urls';
import { setRefundForCode96Dot5 } from '../../../../redux/actions';
import useWizard from '../wizard/useWizard';

const ModalRefundNotApplicable = ({
  accessGranted,
  country,
  dispatch,
  errorFulfillRefund,
  errorQuoteRefund,
  fulfillRefundData,
  handleRetry,
  language,
  refundReason,
  specialRefund,
  storefront,
}) => {
  // Variables
  const { modalRefundNotApplicableValidations } = useWizard();
  const hasErrorFulFillRefund = fulfillRefundData && (
    fulfillRefundData?.fulfillRefundResult?.subCode !== '00'
    || fulfillRefundData?.fulfillRefundResult?.code !== '00'
    || (fulfillRefundData?.refunds || []).every(refund => refund?.refunded === false)
  );
  const errorExists = errorFulfillRefund || errorQuoteRefund || refundReason?.errorRefundReason || !accessGranted;

  // Methods
  const RefundForCode96Dot5 = () => {
    dispatch(setRefundForCode96Dot5(true));
  };

  return (
    <>
      { errorExists ?
        <div className='ModalRefundNotApplicable'>
          <div className='ModalRefundNotApplicable-detailsContainer'>
            <div className='ModalRefundNotApplicable-detailsContainer-warning'>
              <Pictogram className='ModalRefundNotApplicable-detailsContainer-warning--alertIcon' id='RefundCancelAlert' />
              <TranslatedCopy
                className='ModalRefundNotApplicable-detailsContainer-warning--alertText'
                copyID='MYB_TICKETS_NOT_ELIGIBLE_FOR_REFUND'
                tagName='p'
              />
              { !accessGranted ?
                <TranslatedCopy
                  className='ModalRefundNotApplicable-detailsContainer-warning--alertDesc'
                  copyID='MYB_YOUR_EMAIL_DOES_NOT_MATCH'
                  tagName='p'
                />
                : <TranslatedCopy
                  className='ModalRefundNotApplicable-detailsContainer-warning--alertDesc'
                  copyID='MYB_WE_HAVE_AN_INTERMITTENCY_TRY_AGAIN'
                  tagName='p'
                />
              }
            </div>
            { accessGranted &&
              <TranslatedCopy
                className='ModalRefundNotApplicable-detailsContainer--btn'
                copyID='CC_RETRY'
                onClick={ () => handleRetry() }
                tagName='button' />
            }
            <TranslatedCopy
              className='ModalRefundNotApplicable-detailsContainer--btn'
              copyID='MYB_EXIT_REFUND'
              onClick={ () => window.location.href = HomeE4(language, country) }
              tagName='button' />
          </div>
        </div>
        : hasErrorFulFillRefund ?
          <div className='ModalRefundNotApplicable'>
            <div className='ModalRefundNotApplicable-detailsContainer'>
              <div className='ModalRefundNotApplicable-detailsContainer-warning'>
                <Pictogram className='ModalRefundNotApplicable-detailsContainer-warning--alertIcon' id='RefundCancelAlert' />
                <TranslatedCopy
                  className='ModalRefundNotApplicable-detailsContainer-warning--alertText'
                  copyID='MYB_TICKETS_NOT_ELIGIBLE_FOR_FULFILL_REFUND_TITLE'
                  tagName='p'
                />
                <TranslatedCopy
                  className='ModalRefundNotApplicable-detailsContainer-warning--alertDesc'
                  copyID='MYB_WE_HAVE_AN_INTERMITTENCY_TRY_AGAIN'
                  tagName='p'
                />
              </div>
              <TranslatedCopy
                className='ModalRefundNotApplicable-detailsContainer--btn'
                copyID='CC_RETRY'
                onClick={ () => handleRetry() }
                tagName='button'
              />
              <TranslatedCopy
                className='ModalRefundNotApplicable-detailsContainer--btn'
                copyID='MYB_EXIT_REFUND'
                onClick={ () => window.location.href = HomeE4(language, country) }
                tagName='button'
              />
            </div>
          </div>
          :
          <div className='ModalRefundNotApplicable'>
            <div className='ModalRefundNotApplicable-detailsContainer'>
              <div className='ModalRefundNotApplicable-detailsContainer-warning'>
                <Pictogram className='ModalRefundNotApplicable-detailsContainer-warning--alertIcon' id='RefundCancelAlert' />
                <TranslatedCopy
                  className='ModalRefundNotApplicable-detailsContainer-warning--alertText'
                  copyID='MYB_TICKETS_NOT_ELIGIBLE_FOR_REFUND'
                  tagName='p'
                />
                <p className='ModalRefundNotApplicable-detailsContainer-warning--alertDesc'>{ modalRefundNotApplicableValidations?.description }</p>
              </div>
              { modalRefundNotApplicableValidations?.showTaxRefundButton &&
                <TranslatedCopy
                  className='ModalRefundNotApplicable-detailsContainer--btn'
                  copyID='MYB_REQUEST_REFUND_FOR_TAXES'
                  onClick={ () => RefundForCode96Dot5() }
                  tagName='button'
                />
              }
              { modalRefundNotApplicableValidations?.showSpecialRefundButton &&
                <button
                  className='ModalRefundNotApplicable-detailsContainer-specialRefundBtn'
                  onClick={ () => specialRefund(storefront, modalRefundNotApplicableValidations?.reason) }
                >
                  <TranslatedCopy
                    className='ModalRefundNotApplicable-detailsContainer-specialRefundBtn--text'
                    copyID='MYB_REQUEST_SPECIAL_REFUND_FINAL'
                  />
                  <Pictogram className='ModalRefundNotApplicable-detailsContainer-specialRefundBtn--arrowIcon' id='WhiteArrowRight' />
                </button>
              }
              { modalRefundNotApplicableValidations?.showRetryButton &&
                <TranslatedCopy
                  className='ModalRefundNotApplicable-detailsContainer--btn'
                  copyID='CC_RETRY'
                  onClick={ () => handleRetry() }
                  tagName='button' />
              }
              { modalRefundNotApplicableValidations?.showExitButton &&
                <TranslatedCopy
                  className='ModalRefundNotApplicable-detailsContainer--btn'
                  copyID='MYB_EXIT_REFUND'
                  onClick={ () => window.location.href = HomeE4(language, country) }
                  tagName='button' />
              }
            </div>
          </div>
      }
    </>

  );
};

ModalRefundNotApplicable.propTypes = {
  handleRetry: PropTypes.func.isRequired,
  storefront: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  country: state.LanguageBundle.country,
  errorFulfillRefund: state.fulfillRefund.errorFulfillRefund,
  errorQuoteRefund: state.quoteRefund.errorQuoteRefund,
  language: state.Manage.language,
  refundReason: state.refundReason,
  storefront: state.Manage.storefront,
});

export default connect(mapStateToProps)(ModalRefundNotApplicable);